// Tadilat / inşaat kategorileri - 3 seviyeli yapı (Ana > Alt > Detay)
// Her alt başlığın "items" alanı boş veya dolu olabilir; dolu ise 3. dropdown gösterilir.
export const CATEGORIES = [
  {
    name: "Seramik",
    subs: [
      {
        name: "Yer Seramiği",
        items: [
          "30x30 cm",
          "30x60 cm",
          "45x45 cm",
          "60x60 cm",
          "60x120 cm",
          "İşçilik (m²)",
          "Süpürgelik Seramik",
          "Derz Dolgu",
        ],
      },
      {
        name: "Duvar Seramiği",
        items: [
          "20x50 cm",
          "25x40 cm",
          "30x60 cm",
          "60x60 cm",
          "Bordür / Dekor",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Banyo Seramiği",
        items: [
          "Banyo Yer Seramiği",
          "Banyo Duvar Seramiği",
          "Mozaik Dekor",
          "İşçilik (m²)",
          "Su Yalıtımı (Membran)",
        ],
      },
      {
        name: "Mutfak Seramiği (Tezgah Arası)",
        items: ["Cam Mozaik", "Metro Fayans", "60x30 cm", "İşçilik (m²)"],
      },
      {
        name: "Granit Seramik",
        items: ["60x60 cm", "60x120 cm", "80x80 cm", "120x120 cm", "İşçilik (m²)"],
      },
    ],
  },
  {
    name: "Parke",
    subs: [
      {
        name: "Laminat Parke",
        items: [
          "AC4 8mm",
          "AC4 10mm",
          "AC5 8mm",
          "AC5 10mm",
          "AC5 12mm",
          "Süpürgelik 6 cm",
          "Süpürgelik 8 cm",
          "Süpürgelik 10 cm",
          "Şilte / Şok Emici",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Masif Parke",
        items: [
          "Meşe Masif",
          "Ceviz Masif",
          "Iroko Masif",
          "Süpürgelik Masif",
          "Cila / Verniği",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Lamine Parke",
        items: [
          "3 Strip Meşe",
          "1 Strip Meşe",
          "Süpürgelik MDF",
          "Şilte",
          "İşçilik (m²)",
        ],
      },
      {
        name: "LVT / Vinil Parke",
        items: [
          "Click LVT",
          "Yapışkanlı LVT",
          "SPC Parke",
          "Süpürgelik PVC",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Süpürgelik",
        items: [
          "Ahşap 6 cm",
          "Ahşap 8 cm",
          "MDF 6 cm",
          "MDF 8 cm",
          "PVC",
          "Alüminyum",
          "İşçilik (mt)",
        ],
      },
    ],
  },
  {
    name: "Boya",
    subs: [
      {
        name: "İç Cephe Boya",
        items: [
          "Plastik Boya",
          "Silikonlu İç Cephe",
          "Tavan Boyası",
          "Astar",
          "Macun + Zımpara",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Dış Cephe Boya",
        items: [
          "Silikonlu Dış Cephe",
          "Akrilik Dış Cephe",
          "Mantolama Boyası",
          "Astar",
          "İşçilik (m²)",
          "İskele Kurulumu",
        ],
      },
      {
        name: "Tavan Boyası",
        items: ["Mat Tavan Boyası", "Saten Tavan Boyası", "Astar", "İşçilik (m²)"],
      },
      {
        name: "Saten Boya",
        items: ["Saten Boya Beyaz", "Saten Boya Renkli", "Astar", "İşçilik (m²)"],
      },
      {
        name: "Astar",
        items: ["Su Bazlı Astar", "Solvent Bazlı Astar", "İşçilik (m²)"],
      },
      {
        name: "İç Duvar Sıva + Boya",
        items: [
          "Alçı Sıva + Saten + Boya (Komple)",
          "Sıva Tamiri + Boya",
          "Astar + 2 Kat Boya",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Tavan Sıva + Boya",
        items: [
          "Alçı Sıva + Saten + Tavan Boyası (Komple)",
          "Sıva Tamiri + Tavan Boyası",
          "Astar + 2 Kat Tavan Boyası",
          "İşçilik (m²)",
        ],
      },
    ],
  },
  {
    name: "Alçı",
    subs: [
      {
        name: "Alçı Sıva",
        items: ["Makine Alçısı", "Elle Alçı Sıva", "Köşebent", "İşçilik (m²)"],
      },
      {
        name: "Saten Alçı",
        items: ["Saten Alçı Malzeme", "İşçilik (m²)"],
      },
      {
        name: "Kartonpiyer",
        items: [
          "Düz Kartonpiyer 8 cm",
          "Düz Kartonpiyer 10 cm",
          "Desenli Kartonpiyer",
          "Köşe Göbeği",
          "İşçilik (mt)",
        ],
      },
      {
        name: "Alçıpan Duvar",
        items: [
          "Tek Kat Alçıpan",
          "Çift Kat Alçıpan",
          "Yangına Dayanıklı Alçıpan",
          "Suya Dayanıklı (Yeşil) Alçıpan",
          "Profil + Vida",
          "İzolasyon Yünü",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Alçıpan Kaplama (Giydirme)",
        items: [
          "Tek Kat Kaplama",
          "Çift Kat Kaplama",
          "Suya Dayanıklı (Yeşil) Alçıpan",
          "Yangına Dayanıklı Alçıpan",
          "Profil + Vida",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Asma Tavan (Alçıpan)",
        items: [
          "Düz Asma Tavan",
          "Kademeli Asma Tavan",
          "Gizli Işıklı",
          "Profil + Vida",
          "İşçilik (m²)",
        ],
      },
    ],
  },
  {
    name: "Karopan",
    subs: [
      { name: "Karopan Asma Tavan", items: ["60x60 cm", "Profil", "İşçilik (m²)"] },
      { name: "Taşyünü Asma Tavan", items: ["60x60 cm", "Profil", "İşçilik (m²)"] },
      { name: "Metal Asma Tavan", items: ["Beyaz Plaka", "Renkli Plaka", "İşçilik (m²)"] },
    ],
  },
  {
    name: "Duşakabin",
    subs: [
      {
        name: "Duşakabin Montajı",
        items: ["Köşe Duşakabin", "Oval Duşakabin", "Kare Duşakabin", "İşçilik (adet)"],
      },
      {
        name: "Duşakabin Camı",
        items: ["6mm Temperli", "8mm Temperli", "10mm Temperli", "İşçilik (m²)"],
      },
      {
        name: "Duş Teknesi",
        items: ["Akrilik 80x80", "Akrilik 90x90", "Mermer Tekne", "İşçilik (adet)"],
      },
      {
        name: "Küvet",
        items: ["Akrilik Küvet", "Çelik Küvet", "Köşe Küvet", "İşçilik (adet)"],
      },
    ],
  },
  {
    name: "Mutfak",
    subs: [
      {
        name: "Mutfak Dolabı",
        items: [
          "MDF Lake",
          "Akrilik Kapak",
          "Membran Kapak",
          "Ahşap Kapak",
          "Modül Çekmece",
          "Bas Aç (Push)",
          "İşçilik (mt)",
        ],
      },
      {
        name: "Tezgah",
        items: [
          "Granit Tezgah",
          "Kuvars (Çimstone)",
          "Mermer Tezgah",
          "Kompakt Laminat",
          "İşçilik (mt)",
        ],
      },
      {
        name: "Ankastre",
        items: ["Fırın", "Ocak", "Davlumbaz", "Bulaşık Makinesi", "Eviye", "Batarya"],
      },
    ],
  },
  {
    name: "Banyo",
    subs: [
      {
        name: "Tuvalet (WC)",
        items: ["Klozet", "Lavabo", "Lavabo Dolabı", "Rezervuar", "Bide", "Klozet Kapağı", "Taharet Musluğu"],
      },
      {
        name: "Vitrifiye",
        items: ["Klozet", "Lavabo", "Lavabo Dolabı", "Rezervuar", "Bide"],
      },
      {
        name: "Küvet & Jakuzi",
        items: [
          "Standart Küvet",
          "Oturmalı Küvet",
          "Köşe Küvet",
          "Ankastre Küvet",
          "Serbest Duran Küvet",
          "Bebek Küveti",
          "Jakuzi (Masaj Küvet)",
          "Whirlpool Jakuzi",
          "Air Pool Jakuzi",
          "Hidromasaj Sistemi",
          "Küvet Bataryası",
          "Küvet Perde Rayı",
          "Küvet Etek Paneli",
          "Küvet Ayakları",
          "Küvet Sifonu",
          "Küvet Montaj İşçiliği",
        ],
      },
      {
        name: "Armatür",
        items: ["Lavabo Bataryası", "Eviye Bataryası", "Duş Bataryası", "Banyo Bataryası"],
      },
      {
        name: "Aksesuar",
        items: ["Ayna", "Havluluk", "Sabunluk", "Tuvalet Fırçası", "Kağıtlık"],
      },
      {
        name: "Banyo Tavanı",
        items: [
          "PVC Asma Tavan",
          "Alüminyum Asma Tavan",
          "Suya Dayanıklı Alçıpan Tavan",
          "Spot Delikleri",
          "İşçilik (m²)",
        ],
      },
    ],
  },
  {
    name: "Elektrik",
    subs: [
      {
        name: "Tesisat",
        items: [
          "Antigron Kablo 2.5",
          "Antigron Kablo 4mm",
          "Spiral Boru",
          "Kasa",
          "İşçilik (mt)",
        ],
      },
      {
        name: "Anahtar / Priz",
        items: ["Anahtar", "Priz", "TV/Data Prizi", "USB Prizi", "Komütatör"],
      },
      {
        name: "Aydınlatma",
        items: ["LED Spot", "LED Avize", "Aplik", "LED Şerit", "Sarkıt"],
      },
      {
        name: "Pano",
        items: ["Sigorta", "Kaçak Akım", "Sayaç Panosu", "İşçilik (adet)"],
      },
    ],
  },
  {
    name: "Sıhhi Tesisat",
    subs: [
      {
        name: "Boru",
        items: ["PPRC 20mm", "PPRC 25mm", "PPRC 32mm", "Pis Su 50", "Pis Su 100"],
      },
      {
        name: "Vana / Bağlantı",
        items: ["Küresel Vana", "Çekvalf", "Filtre", "Bağlantı Parçaları"],
      },
      {
        name: "Kombi / Şofben",
        items: ["Yoğuşmalı Kombi", "Hermetik Kombi", "Şofben", "Termosifon"],
      },
    ],
  },
  {
    name: "Kapı / Pencere",
    subs: [
      {
        name: "İç Kapı",
        items: ["Amerikan Panel Kapı", "MDF Lake Kapı", "Ahşap Kapı", "Kasa + Pervaz", "Menteşe + Kilit"],
      },
      {
        name: "Dış Kapı / Çelik",
        items: ["Standart Çelik Kapı", "Lüks Çelik Kapı", "Villa Kapısı"],
      },
      {
        name: "PVC Pencere",
        items: ["Tek Cam", "Isı Cam", "Üç Kanatlı", "Sineklik", "İşçilik (m²)"],
      },
      {
        name: "Alüminyum Doğrama",
        items: ["Sürme Sistem", "Açılır Sistem", "Cephe Sistemi", "İşçilik (m²)"],
      },
    ],
  },
  {
    name: "Şap / İzolasyon",
    subs: [
      {
        name: "Şap",
        items: ["Tesviye Şap", "İç Mekan Şap", "Mozaik Şap", "Isı Yalıtım Şap", "İşçilik (m²)"],
      },
      {
        name: "Su Yalıtımı",
        items: ["Çift Bileşenli", "Membran", "Likit Membran", "İşçilik (m²)"],
      },
      {
        name: "Isı Yalıtımı (Mantolama)",
        items: ["3 cm EPS", "5 cm EPS", "5 cm Taşyünü", "İşçilik (m²)"],
      },
    ],
  },
  {
    name: "Tente",
    subs: [
      {
        name: "Mafsallı Tente",
        items: [
          "Manuel Mafsallı Tente",
          "Motorlu Mafsallı Tente",
          "Uzaktan Kumandalı",
          "Rüzgar Sensörlü",
          "Tente Bezi (Akrilik)",
          "Tente Bezi (PVC)",
          "İşçilik (m²)",
          "Montaj (adet)",
        ],
      },
      {
        name: "Damla / Panorama Tente",
        items: [
          "Damla Tente",
          "Panorama Tente",
          "Balkon Tentesi",
          "Kollu Tente",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Pergola Tente",
        items: [
          "Bioklimatik Pergola",
          "Sabit Pergola",
          "Motorlu Pergola",
          "Ahşap Pergola",
          "Alüminyum Konstrüksiyon",
          "Yan Kapama Cam Sistem",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Sabit Sundurma / Cephe",
        items: [
          "Polikarbon Sundurma",
          "Cam Sundurma",
          "Metal Konstrüksiyon Sundurma",
          "Cephe Güneşliği",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Tente Bezi / Kumaş",
        items: [
          "Akrilik Kumaş",
          "PVC Kumaş",
          "Muşamba",
          "Gölgelik File",
          "Dikiş / Fitil",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Tente Aksesuar",
        items: [
          "Tüp Motor",
          "Uzaktan Kumanda",
          "Rüzgar Sensörü",
          "Güneş Sensörü",
          "Manuel Kol",
          "Braket / Konsol",
          "LED Aydınlatma Şeridi",
        ],
      },
    ],
  },
  {
    name: "Demir / Kaynak",
    subs: [
      {
        name: "Saç Levha",
        items: [
          "DKP Saç 1 mm",
          "DKP Saç 2 mm",
          "DKP Saç 3 mm",
          "DKP Saç 4 mm",
          "DKP Saç 5 mm",
          "Galvanizli Saç 0.5 mm",
          "Galvanizli Saç 1 mm",
          "Baklava Desenli Saç",
          "Delikli Saç",
          "İşçilik (kg)",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Paslanmaz Levha",
        items: [
          "304 Kalite 1 mm",
          "304 Kalite 2 mm",
          "316 Kalite 1 mm",
          "316 Kalite 2 mm",
          "Ayna Yüzey",
          "Fırçalı (Satine) Yüzey",
          "İşçilik (kg)",
        ],
      },
      {
        name: "Kompozit (Composit) Levha",
        items: [
          "Alüminyum Kompozit 3 mm",
          "Alüminyum Kompozit 4 mm",
          "PVDF Boyalı Kompozit",
          "Ahşap Görünümlü Kompozit",
          "Yanmaz (A2) Kompozit",
          "Alt Konstrüksiyon Profili",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Profil / Boru (Kutu)",
        items: [
          "Kutu Profil 20x20",
          "Kutu Profil 30x30",
          "Kutu Profil 40x40",
          "Kutu Profil 50x50",
          "Dikdörtgen Profil 40x20",
          "NPU Profil",
          "Köşebent / Lama",
          "İşçilik (kg)",
        ],
      },
      {
        name: "Kaynak İşçiliği",
        items: [
          "Gazaltı (MIG/MAG)",
          "Argon (TIG)",
          "Elektrik Ark (Elektrot)",
          "Nokta Kaynak",
          "Sac Bükme / Kesim",
          "Lazer Kesim",
          "İşçilik (saat)",
          "İşçilik (mt)",
        ],
      },
      {
        name: "Korkuluk / Ferforje",
        items: [
          "Balkon Korkuluğu",
          "Merdiven Korkuluğu",
          "Cam + Paslanmaz Korkuluk",
          "Ferforje Kapı",
          "Bahçe Çiti / Kapısı",
          "Boya / Astar",
          "İşçilik (mt)",
        ],
      },
      {
        name: "Demir Doğrama / Konstrüksiyon",
        items: [
          "Çelik Konstrüksiyon",
          "Merdiven İskeleti",
          "Çatı Makası",
          "Sanayi Kapısı",
          "Depo Rafı",
          "Antipas + Boya",
          "İşçilik (kg)",
        ],
      },
    ],
  },
  {
    name: "Duvar",
    subs: [
      {
        name: "Duvar Örme",
        items: [
          "Tuğla 13,5'luk",
          "Tuğla 19'luk",
          "Gazbeton 10 cm",
          "Gazbeton 15 cm",
          "Gazbeton 20 cm",
          "Bims Blok",
          "Örgü Harcı / Yapıştırıcı",
          "Lento / Hatıl",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Duvar Sıvası",
        items: [
          "Kaba Sıva",
          "İnce Sıva",
          "Kara Sıva",
          "Hazır Sıva (Torba)",
          "Sıva Filesi",
          "Köşe Profili",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Alçıpan Bölme Duvar",
        items: [
          "Tek Kat Tek İskelet",
          "Çift Kat Çift İskelet",
          "Yeşil Alçıpan (Suya Dayanıklı)",
          "Ses Yalıtımlı Bölme",
          "Taş Yünü Dolgu",
          "Profil (DU/DC)",
          "Derz Bandı + Macun",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Duvar Boyası",
        items: [
          "Astar",
          "Plastik Boya",
          "Silikonlu Boya",
          "Saten Boya",
          "Macun (Alçı/Saten)",
          "Dekoratif Efekt Boya",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Duvar Kağıdı",
        items: [
          "Vinil Duvar Kağıdı",
          "İthal Duvar Kağıdı",
          "Poster / Özel Baskı",
          "Tutkal / Yapıştırıcı",
          "Eski Kağıt Sökümü",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Duvar Kaplama",
        items: [
          "Doğal Taş Kaplama",
          "Kültür Taşı",
          "Tuğla Görünümlü Kaplama",
          "Ahşap Lambri",
          "PVC Duvar Paneli",
          "Dekoratif 3D Panel",
          "Mermer Kaplama",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Duvar Yalıtımı",
        items: [
          "Mantolama EPS 5 cm",
          "Mantolama EPS 8 cm",
          "Mantolama Taş Yünü",
          "İç Cephe Isı Yalıtımı",
          "Ses Yalıtımı",
          "Su Yalıtımı (Bodrum/Islak Hacim)",
          "File + Yapıştırıcı + Dübel",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Duvar Yıkım / Tadilat",
        items: [
          "Duvar Yıkımı (m²)",
          "Niş / Kanal Açma",
          "Karot Delme",
          "Moloz Atımı (torba)",
          "Moloz Atımı (kamyon)",
          "İşçilik",
        ],
      },
    ],
  },
  {
    name: "Çatı İzolasyonu",
    subs: [
      {
        name: "Membran İzolasyon",
        items: [
          "Su Yalıtım Membranı (3 mm)",
          "Su Yalıtım Membranı (4 mm arduazlı)",
          "Alüminyum Folyolu Membran",
          "Bitüm Astar",
          "Şalümo Gazı / Sarf",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Isı Yalıtımı",
        items: [
          "Cam Yünü (8 cm)",
          "Taş Yünü (10 cm)",
          "XPS Levha (5 cm)",
          "Buhar Dengeleyici Örtü",
          "OSB Levha",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Likit / Sürme İzolasyon",
        items: [
          "Likit Membran (2 Kat)",
          "Poliüretan Esaslı Sürme İzolasyon",
          "Geotekstil Keçe",
          "İşçilik (m²)",
        ],
      },
    ],
  },
  {
    name: "Çatı Kaplama",
    subs: [
      {
        name: "Kiremit Kaplama",
        items: [
          "Kiremit (Marsilya)",
          "Kiremit (Granada / Valensiya)",
          "Mahya Kiremidi",
          "Kiremit Altı Membranı",
          "Çatı Çıtası / Lata",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Shingle Kaplama",
        items: [
          "Shingle (Standart)",
          "Shingle (Dikdörtgen / Bitümlü)",
          "OSB Levha",
          "Membran Altlık",
          "Mahya Bandı",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Metal Kiremit",
        items: [
          "Metal Kiremit Panel",
          "Mahya / Kapama Profili",
          "Vida + Conta",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Çatı Altyapısı",
        items: [
          "OSB Levha",
          "Tahta Kaplama",
          "Buhar Dengeleyici Örtü",
          "Baca Dibi Yalıtımı",
          "Çatı Penceresi Çevresi Yalıtım",
          "İşçilik (m²)",
        ],
      },
    ],
  },
  {
    name: "Trapez Sac Döşeme",
    subs: [
      {
        name: "Sac Malzeme",
        items: [
          "Trapez Sac (Boyalı 0,50 mm)",
          "Trapez Sac (Galvaniz)",
          "Alüminyum Trapez",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Konstrüksiyon / Aşık",
        items: [
          "Kutu Profil Aşık",
          "C / Z Profil Aşık",
          "Kaynak + Montaj",
          "Antipas + Boya",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Kapama & Aksesuar",
        items: [
          "Mahya Kapama",
          "Yan Kapama / Duvar Dibi",
          "Matkap Uçlu Vida + Pul",
          "Silikon / Sızdırmazlık",
          "İşçilik (mtül)",
        ],
      },
      {
        name: "Işıklık",
        items: [
          "Polikarbon Levha",
          "CTP (Fiberglas) Levha",
          "Montaj İşçiliği",
        ],
      },
    ],
  },
  {
    name: "Panel Döşeme",
    subs: [
      {
        name: "Çatı Sandviç Paneli",
        items: [
          "Sandviç Panel 5 cm (Poliüretan)",
          "Sandviç Panel 8 cm (Poliüretan)",
          "Sandviç Panel 10 cm (Taş Yünü)",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Cephe Paneli",
        items: [
          "Cephe Paneli 5 cm",
          "Cephe Paneli 8 cm",
          "Gizli Vidalı Cephe Paneli",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Panel Aksesuarları",
        items: [
          "Mahya / Kapama Aksesuarları",
          "Köşebent / Bitiş Profili",
          "Panel Vidası + Conta",
          "Işıklık Paneli",
          "İşçilik (mtül)",
        ],
      },
    ],
  },
  {
    name: "Dere İzolasyonu",
    subs: [
      {
        name: "Membran Uygulama",
        items: [
          "Dere Membranı (Alüminyum Folyolu)",
          "Su Yalıtım Membranı (3 mm)",
          "Bitüm Astar",
          "İşçilik (mtül)",
        ],
      },
      {
        name: "Likit Uygulama",
        items: [
          "Likit Membran (2 Kat)",
          "Poliüretan Mastik",
          "Geotekstil Keçe",
          "İşçilik (mtül)",
        ],
      },
      {
        name: "Bakım & Aksesuar",
        items: [
          "Dere Temizliği",
          "Dere Süzgeci",
          "Sac Dere Değişimi",
          "İşçilik (mtül)",
        ],
      },
    ],
  },
  {
    name: "Oluk Yapımı",
    subs: [
      {
        name: "Oluk Malzemesi",
        items: [
          "PVC Oluk",
          "Alüminyum Oluk",
          "Galvaniz / Boyalı Sac Oluk",
          "Bakır Oluk",
          "İşçilik (mtül)",
        ],
      },
      {
        name: "İniş & Bağlantı",
        items: [
          "Yağmur İniş Borusu",
          "Dirsek / Ağız",
          "Oluk Süzgeci",
          "Kelepçe",
          "İşçilik (mtül)",
        ],
      },
      {
        name: "Montaj & Sızdırmazlık",
        items: [
          "Oluk Askısı",
          "Silikon / Sızdırmazlık",
          "Montaj İşçiliği (mtül)",
        ],
      },
    ],
  },
  {
    name: "Teras",
    subs: [
      {
        name: "Teras Şapı",
        items: ["Eğim Şapı", "Tesviye Şap", "İşçilik (m²)"],
      },
      {
        name: "Teras Seramiği (Alt)",
        items: ["Alt Seramik Döşeme", "Yapıştırıcı + Derz", "İşçilik (m²)"],
      },
      {
        name: "Teras Seramiği (Üst)",
        items: ["Üst Seramik Döşeme", "Yapıştırıcı + Derz", "İşçilik (m²)"],
      },
      {
        name: "Üst Tabliye + Teras Çesan",
        items: [
          "Üst Tabliye Betonu",
          "Çesan (Çimento Esaslı Su Yalıtımı)",
          "File + Astar",
          "İşçilik (m²)",
        ],
      },
    ],
  },
  {
    name: "Peyzaj & Bahçe",
    subs: [
      {
        name: "Zemin Kaplaması",
        items: [
          "Bahçe Karo Taşı",
          "Dekoratif Beton",
          "Andezit Taş",
          "Traverten",
          "Bazalt Küp Taş",
          "Granit Küp Taş",
          "Ahşap Deck (WPC)",
          "Ahşap Deck (Iroko)",
          "Ahşap Deck (Bangkirai)",
          "Sun'i Çim (Sentetik)",
          "Doğal Çim (Ruloçim)",
          "Çakıl / Mıcır Serimi",
          "Bordür (Beton)",
          "Bordür (Granit)",
          "İşçilik (m²)",
        ],
      },
      {
        name: "Bitki & Ağaç",
        items: [
          "Çim Tohumu",
          "Çim Rulo",
          "Mevsimlik Çiçek",
          "Çalı / Şimşir",
          "Yer Örtücü Bitki",
          "Ağaç Fidanı",
          "Meyve Ağacı",
          "Servi Ağacı",
          "Palmiye",
          "Bitki Toprağı (Torf)",
          "Peat Moss / Gübre",
          "Bitki Dikim İşçiliği",
        ],
      },
      {
        name: "Sulama Sistemi",
        items: [
          "Otomatik Sulama (Sprinkler)",
          "Damla Sulama Hattı",
          "Sulama Boru (PE 25mm)",
          "Sulama Boru (PE 32mm)",
          "Selenoid Vana",
          "Sulama Kontrol Ünitesi",
          "Hidrofor",
          "Su Deposu (1 Ton)",
          "İşçilik (mt)",
        ],
      },
      {
        name: "Bahçe Yapıları",
        items: [
          "Pergola (Ahşap)",
          "Pergola (Metal)",
          "Bioclimatic Pergola (Motorlu)",
          "Kamelya",
          "Kameriye",
          "Ahşap Çardak",
          "Ahşap Bahçe Kulübesi",
          "Havuz (Prefabrik)",
          "Süs Havuzu",
          "Şelale / Su Öğesi",
          "Barbekü / Mangal",
          "Fırın (Pizza / Ekmek)",
          "Bahçe Duvarı (Taş)",
          "Bahçe Çiti (Ahşap)",
          "Bahçe Çiti (Metal)",
          "Kapı / Bahçe Kapısı",
        ],
      },
      {
        name: "Aydınlatma",
        items: [
          "Bahçe Direği Aydınlatma",
          "Yer Spot (LED)",
          "Ağaç Aydınlatma Spotu",
          "Gömme Zemin Aydınlatma",
          "Solar Bahçe Lambası",
          "Duvar Aplik",
          "Aydınlatma Kablo (Antigron)",
          "Aydınlatma İşçilik (mt)",
        ],
      },
      {
        name: "Peyzaj Dekor",
        items: [
          "Süs Kayası",
          "Taş Duvarcık",
          "Saksı (Toprak / Beton)",
          "Bahçe Heykeli",
          "Bahçe Banki",
          "Yürüyüş Yolu Taşı (Stepping)",
          "Kum Havuzu (Çocuk)",
          "Salıncak / Oyun Grubu",
        ],
      },
      {
        name: "Alt Yapı / Drenaj",
        items: [
          "Drenaj Borusu (Delikli)",
          "Filtre Kumaşı (Geotekstil)",
          "Yağmur Suyu Rögarı",
          "Bahçe Su Girişi",
          "Su Yalıtım Membranı",
          "Toprak Tesviyesi",
          "İşçilik (m²)",
        ],
      },
    ],
  },
  {
    name: "Diğer",
    subs: [
      { name: "Hafriyat / Yıkım", items: ["Duvar Yıkımı (m²)", "Moloz Çıkışı (kamyon)"] },
      { name: "Temizlik", items: ["İnşaat Sonrası Temizlik (m²)"] },
      { name: "Nakliye", items: ["Şehir İçi", "Şehir Dışı (km)"] },
    ],
  },
];

const SEP = " - ";

// 3 seviyeli birleştirme: "Ana - Alt - Detay"
export const joinCategory = (main, sub, item) => {
  const parts = [main, sub, item].filter((p) => p && String(p).trim() !== "");
  return parts.join(SEP);
};

// Geriye uyumlu parse: "Ana - Alt - Detay" veya "Ana - Alt" veya "Ana"
export const splitCategory = (value) => {
  if (!value) return { main: "", sub: "", item: "" };
  const parts = String(value).split(SEP);
  return {
    main: parts[0] || "",
    sub: parts[1] || "",
    item: parts.slice(2).join(SEP) || "",
  };
};

// Yardımcı: bir ana kategorinin alt başlık adlarını getir (sub.name veya raw string)
export const getSubNames = (mainCat) => {
  if (!mainCat || !Array.isArray(mainCat.subs)) return [];
  return mainCat.subs.map((s) => (typeof s === "string" ? s : s.name));
};

// Yardımcı: bir alt başlığın detay (item) listesini getir
export const getSubItems = (mainCat, subName) => {
  if (!mainCat || !Array.isArray(mainCat.subs)) return [];
  const sub = mainCat.subs.find(
    (s) => (typeof s === "string" ? s : s.name) === subName
  );
  if (!sub || typeof sub === "string") return [];
  return Array.isArray(sub.items) ? sub.items : [];
};
